import { Images } from '../assets'
import React, { useState, useRef, useEffect } from 'react'
import emailjs from '@emailjs/browser';
import PageTitle from '../components/PageTitle'
import ReCAPTCHA from "react-google-recaptcha"

const sendEmailWithTimeout = (serviceId, templateId, templateParams, timeoutMs = 30000) => {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject({ text: 'Request timed out. Please check your connection and try again.' })
    }, timeoutMs)

    emailjs.send(serviceId, templateId, templateParams)
      .then((result) => {
        clearTimeout(timeoutId)
        resolve(result)
      })
      .catch((err) => {
        clearTimeout(timeoutId)
        reject(err)
      })
  })
}

const Spinner = () => (
  <svg className="animate-spin h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
)

const Getintouch = () => {

    const [name, setName] = useState("")
    const [organisation, setOrganisation] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [loader, setLoader] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [submitBtn, setsubmitBtn] = useState(false)

     const recaptcha = useRef()


    useEffect(() => {
      if(name !== "" && organisation !== "" && email !== "" && message !== ""){
        setsubmitBtn(true)
      }else{
        setsubmitBtn(false)
      }
      return () => {}
    },[name, organisation, email, message])
    

     useEffect(() => {
       if (!process.env.REACT_APP_EMAILJS_KEY) {
         console.error('EmailJS public key is missing. Check your environment variables.')
         return
       }
       emailjs.init({
         publicKey: process.env.REACT_APP_EMAILJS_KEY,
         blockHeadless: true,
         limitRate: {
           id: 'app',
           throttle: 10000,
         },
       })
     }, [])

     const clearFields = () =>{
        setName("")
        setOrganisation("")
        setMessage("")
        setEmail("")
    }

    const submitForm = async (e) => {
        e.preventDefault()
        setError(false)
        setErrorMessage('')

        if (!process.env.REACT_APP_SERVICEID || !process.env.REACT_APP_TEMPLATEID || !process.env.REACT_APP_EMAILJS_KEY) {
            setError(true)
            setErrorMessage('Email service is not configured. Please contact us directly at info@seamhealth.com.')
            return
        }

        if (!recaptcha.current) {
            setError(true)
            setErrorMessage('reCAPTCHA has not loaded. Please refresh the page and try again.')
            return
        }

        const captchaValue = recaptcha.current.getValue()
        if (!captchaValue) {
            setError(true)
            setErrorMessage('Please verify the reCAPTCHA.')
            return
        }

        setLoader(true)

        try {
            const templateParams = {
                name,
                organisation,
                email,
                messageBody: message,
            }

            const result = await sendEmailWithTimeout(process.env.REACT_APP_SERVICEID, process.env.REACT_APP_TEMPLATEID, templateParams)
            console.info('EmailJS send succeeded:', result)
            clearFields()
            setSuccess(true)
            setError(false)
            recaptcha.current.reset()
        } catch (err) {
            console.error('EmailJS send failed:', err)
            setError(true)
            setErrorMessage(err?.text || 'Something went wrong. Please try again or email us directly at info@seamhealth.com.')
            recaptcha.current.reset()
        } finally {
            setLoader(false)
        }
    }
    
  return (
    <>
        <PageTitle title="Contact SeamHealth Innovations | Health Technology Consulting" /> 
        <div id='address-section' className="contact-section pt-28 md:pt-52 p-4 md:p-8 flex justify-between flex-col gap-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div data-aos="fade-up" className='text-white '>
                <h1 className="text-5xl font-bold">Get in Touch</h1>
              </div>
              <p data-aos="fade-up" className='text-white'>
                Whether you are scoping a new programme, evaluating an existing system, or looking for a delivery partner, we would like to hear from you.
              </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 md:gap-8 items-end">
              <div data-aos="fade-up" className='text-white grid grid-cols-1 gap-6'>
                <div>
                    <p className='text-primary50 font-medium mb-3'>Our details</p>
                    <p className='font-semibold'>SeamHealth Innovations Ltd.</p>
                    <div className="mt-4">
                      <p className='text-primary50 text-sm mb-0.5'>Location</p>
                      <p>7207 Lyndsey Way,</p>
                      <p>Elkridge, Maryland, 21075</p>
                      <br />
                      <p>62, Emeritus Shehu Umar Street (5th Floor, Tower A),</p>
                      <p>Abuja, Nigeria.</p>
                    </div>
                    <div className="mt-4">
                        <p className='text-primary50 text-sm mb-0.5'>Email</p>
                        <p>info@seamhealth.com</p>
                    </div>
                    <div className="mt-4">
                        <p className='text-primary50 text-sm mb-0.5'>LinkedIn</p>
                        <a href="https://www.linkedin.com/company/seamhealth/" target="_blank" rel="noreferrer" className="inline-block hover:opacity-80 transition-opacity">
                            <img decoding="async" src={Images.LinkedinIcon} alt="Connect with us on LinkedIn" className="w-5 h-5 brightness-0 invert" loading="lazy" />
                        </a>
                    </div>
                </div>
              </div>
              
              <div className='map-container'>
                    <div><img decoding="async" className='map' draggable={false} src={Images.MapBg} alt="" loading="lazy" /></div>
                  <a href="#message-section" className='py-4 md:py-0'>
                    <div className='message-cta flex gap-3 items-center justify-center md:justify-end'>
                        <img decoding="async" src={Images.CircleIcon} alt="" loading="lazy" />
                        <p className='text'>Write us a message</p>
                    </div>
                              </a>
              </div>
          </div>
        </div>
            
        <div id='message-section' className="message-section pt-28 md:pt-52 p-4 md:p-8 grid grid-cols-1 md:grid-cols-2">
            <div className="flex flex-col justify-between items-start">
                <div data-aos="fade-up" className=''>
                    <h4 className="heading-four mb-4">Send us a message</h4>
                    <p className='text-gray'>Alternatively, you can reach us directly at info@seamhealth.com</p>
                </div>

                <a href="#address-section" className=''>
                <div className='address-cta md:flex gap-3 items-center justify-end hidden '>
                    <img decoding="async" src={Images.CircleIconAlt} alt="" loading="lazy" />
                    <p className='text'>Our details</p>
                </div>
            </a>
            </div>

            <div data-aos="fade-up" className='form w-max mt-8 md:mt-0' >
                {success ? <div className="success-message p-4 rounded-lg w-full text-center text-green-700 bg-green-200">
                    Thank you. We have received your message and will be in touch within two business days.
                </div> : <></>}
                {error ? <div className="error-message p-4 rounded-lg w-full text-center text-red-700 bg-red-200">
                    {errorMessage}
                </div> : <></>}
                <form method='POST' onSubmit={submitForm}>
                <div className="f-inner">
                    <div className="form-group w-full">
                        Full name
                        <input value={name} type="text" onChange={(e) => setName(e.target.value)} className="form-control w-full" placeholder='Your full name' required />
                        <img decoding="async" src={Images.UserIcon} alt="" loading="lazy" />
                    </div>
                    
                    <div className="form-group w-full">
                        Organisation
                        <input value={organisation} type="text" onChange={(e) => setOrganisation(e.target.value)} className="form-control w-full" placeholder='Your organisation or institution' required />
                        <img decoding="async" src={Images.UserIcon} alt="" loading="lazy" />
                    </div>

                    <div className="form-group w-full">
                        Email address
                        <input value={email} type="email" onChange={(e) => setEmail(e.target.value)} className="form-control w-full" placeholder='your@email.com' required />
                        <img decoding="async" src={Images.MailIcon} alt="" loading="lazy" />
                    </div>
                    
                    <div className=" w-full">
                        What are you working on?
                        <textarea value={message} onChange={(e) => setMessage(e.target.value)} name="" id="" cols="4" rows={10} className='form-control w-full' placeholder='Tell us about your programme, your challenge, or what you are looking for.' required></textarea>
                    </div>
                    <ReCAPTCHA 
                        sitekey={process.env.REACT_APP_SITE_KEY}
                        ref={recaptcha}
                    />
                        
                    <div className='w-full'>
                        <button
                            type='submit'
                            disabled={loader || !submitBtn}
                            className={!submitBtn ? 'btn btn-primary w-full md:w-max disabled' : 'btn btn-primary w-full md:w-max'}
                        >
                            {loader ? (
                                <span className='inline-flex items-center gap-2'>
                                    <Spinner /> Sending...
                                </span>
                            ) : 'Send message'}
                        </button>
                    </div>
                </div>
                </form>
            </div>
        </div>

        {/* What Happens Next */}
        <section className="bg-[#F8F9FB] py-40 md:py-48">
          <div className="max-w-[1280px] mx-auto px-8 md:px-12">
          <h4 data-aos="fade-up" className="heading-four text-center mb-20">What happens next</h4>
          <div className="grid md:grid-cols-3 gap-12 md:gap-16">
            <div data-aos="fade-up" className="text-center">
              <div className="w-12 h-12 rounded-full bg-[#F3F8FF] flex items-center justify-center mx-auto mb-6">
                <span className="text-[#007DD6] font-semibold text-lg">1</span>
              </div>
              <p className="text-[#2A2A2A] leading-relaxed">
                We read every message. You will receive a response from a member of our team, not an automated reply.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay="100" className="text-center">
              <div className="w-12 h-12 rounded-full bg-[#F3F8FF] flex items-center justify-center mx-auto mb-6">
                <span className="text-[#007DD6] font-semibold text-lg">2</span>
              </div>
              <p className="text-[#2A2A2A] leading-relaxed">
                We aim to respond within 24 hours. For time-sensitive enquiries, note that in your message.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay="200" className="text-center">
              <div className="w-12 h-12 rounded-full bg-[#F3F8FF] flex items-center justify-center mx-auto mb-6">
                <span className="text-[#007DD6] font-semibold text-lg">3</span>
              </div>
              <p className="text-[#2A2A2A] leading-relaxed">
                If your enquiry is a good fit for our services, we will arrange a call to understand your programme in more detail before proposing anything.
              </p>
            </div>
          </div>
          </div>
        </section>
    </>
  )
}

export default Getintouch
